var _defs, _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5, _path6, _polygon;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentSaveAsViewpointSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PresentSaveAsViewpoint_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.49,32V28.71a24.83,24.83,0,0,0-3.39.17c-4.17.48-5.28,3.12-5.28,3.12,0-6.41,8.67-7.08,8.67-7.08v-3l7.51,5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.04,
    y: 19.25,
    width: 2,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,21.25H13v-2h2Zm-4,0H9v-2h2Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.04,
    y: 19.25,
    width: 2,
    height: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,17.47H5V15.7H7Zm0-3.54H5V12.16H7Zm0-3.54H5V8.62H7Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.04,
    y: 4.84,
    width: 2,
    height: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,6.84H13v-2h2Zm-4,0H9v-2h2Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.04,
    y: 4.84,
    width: 2,
    height: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,17.47H17V15.7h2Zm0-3.54H17V12.16h2Zm0-3.54H17V8.62h2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.5,3.5H6V2H2V6H3.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.14 24.14 22.14 24.14 22.14 20.14 20.64 20.14 20.64 22.64 18.14 22.64 18.14 24.14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentSaveAsViewpointSvg);
export default __webpack_public_path__ + "static/media/PresentSaveAsViewpoint_svg.604c17a227db414554011ebd5663a4aa.svg";
export { ForwardRef as ReactComponent };